import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3k1jvsslk: FaireProductEntity = {
  token: "p_b3k1jvsslk",
  type: "product",
  name: "Mascara | Clean Beauty – Volumizing, Lengthening & Non-Toxic",
  brandToken: "b_129dsr49u5",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/e9e070a0b629feead2c3b55c9feb9f412c9ebfcd433de3423ae39ecbb7d8371b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0628777989b4710c758ad025be7a76f2438eb1839d61aae29d6632299a3b9e01.png",
    "https://cdn.faire.com/fastly/ca1c25a4cd7a283a0cdc3634ec833d4af21ecc03f23e995b4c2e92234166fd9d.png",
    "https://cdn.faire.com/fastly/62287f4757d69a9729516122c9480e38bc8a8774a4184068259a5bbb30ba9d2c.png",
    "https://cdn.faire.com/fastly/07686676d516dbf28e6a05abc8ce90bafd5d6dd806be4c748f9e6f2aa107ca33.png",
    "https://cdn.faire.com/fastly/9f6ffe04ce38ab7ccb9137f5edbe6dfc435638103a16c0e597a6cbb24384f6dd.png",
    "https://cdn.faire.com/fastly/67ee676ab0822a546e40f27ea175e81356e6f7534609b85c7ac0af80fc9aef72.png",
    "https://cdn.faire.com/fastly/895523bcaccc79318afd3b02a94ac618f39518356cb4f9722e93917e9b393ed8.png",
    "https://cdn.faire.com/fastly/4b05714e23e89b4122b88cff8c392b6d08bf16491678398816292702c42eafa7.png",
  ],
  priceDollars: 15,
  description:
    "Volumizing, lengthening clean beauty mascara with coffee oil, vitamin E & rosemary. Smudge-proof, water-resistant, safe for sensitive eyes.\n\nElevate your lash game with our Clean Beauty Mascara, a revolutionary formula that delivers voluminous, lifted, and lengthened lashes—without toxins or irritation. Perfect for sensitive eyes, this non-toxic mascara nourishes as it defines, giving you bold, beautiful lashes with a clean conscience.\n\nPowered by a blend of lash-loving botanicals, including:\nCoffee Seed Oil – rich in antioxidants to protect and strengthen lashes.\nVitamin E – defends against free radical damage for healthier growth.\nRosemary Extract – supports circulation to lash follicles for fuller, longer lashes over time.\n\n✔ Volumizing & Lengthening\n✔ Curl & Lift\n✔ Smudge-Proof & Water-Resistant\n✔ Gentle, Nourishing & Safe for Sensitive Eyes\n✔ Easy Removal with our Micellar Makeup Remover\n\nCrafted with 88% organic, vegan, and cruelty-free ingredients, this mascara is free of dyes, harsh chemicals, fragrance, preservatives, parabens, phthalates, and GMOs.\n\nYour lashes deserve clean beauty—ditch the harsh formulas and choose mascara that loves your lashes back.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:12.252Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
